module.exports = __webpack_public_path__ + "static/media/footer-icon-linkedin.05f5c201.svg";